import { configureStore } from "@reduxjs/toolkit"
import authReducer from "./features/auth/authSlice"
import chatReducer from "./features/chat/chatSlice"
import userReducer from "./features/user/userSlice"

const Store = configureStore({
    reducer: {
        auth: authReducer,
        user: userReducer,
        chat: chatReducer
    },
    devTools:false
})

export default Store
